export const localStorageConstants: any = {
  USER_PREFERENCE_KEY: 'userPreference',
  USER_FACILITIES_KEY: 'userFacilities',
};

export const permissionConstants: any = {
  energyCredits: ['EnergyCreditsAdmin', 'EnergyCreditsUser'],
  qBuilt: 'FacilityQBuiltAdmin',
  qBuiltInspector: 'FacilityQBuiltUser',
  siteAdmin: 'SiteAdmin',
  homeOfficeAdmin: 'HomeOfficeQBuiltAdmin',
};

export const breakpointConstants: any = {
  smallScreenSize: 800,
  mobileScreenSize: 600,
  below1150Size: 1150,
  below1000Size: 1000,
};
